import React from "react";
import Hero from "../../components/sections/Hero/Hero";

const Home = () => {
    return (
        <div className="bg-background min-h-screen">
            <Hero/>
        </div>
    )
}

export default Home;